import { render, staticRenderFns } from "./WikiHome.vue?vue&type=template&id=7bc334f6&"
import script from "./WikiHome.vue?vue&type=script&lang=js&"
export * from "./WikiHome.vue?vue&type=script&lang=js&"
import style0 from "./WikiHome.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports